import React from 'react';
import { Form, Input, Select, Button, Row, Col, Drawer } from 'antd';
import { SearchOutlined, FilterOutlined, ReloadOutlined } from '@ant-design/icons';

const { Option } = Select;

const ShopifyVariantsFilter = ({ visible, setVisible, onApply, onReset, currentFilters }) => {
    const [form] = Form.useForm();

    React.useEffect(() => {
        if (visible) {
            form.setFieldsValue(currentFilters);
        }
    }, [visible, currentFilters, form]);

    const handleApply = () => {
        const values = form.getFieldsValue();
        onApply(values);
    };

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <>
            <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
                <Col flex="auto">
                    <Input
                        placeholder="Search by variant title, SKU, barcode..."
                        prefix={<SearchOutlined />}
                        value={currentFilters.searchText}
                        onChange={(e) => onApply({ ...currentFilters, searchText: e.target.value })}
                        allowClear
                    />
                </Col>
                <Col>
                    <Button
                        icon={<FilterOutlined />}
                        onClick={() => setVisible(true)}
                    >
                        Advanced Filters
                    </Button>
                </Col>
            </Row>

            <Drawer
                title="Advanced Filters"
                placement="right"
                width={400}
                onClose={() => setVisible(false)}
                open={visible}
                footer={
                    <Row gutter={8}>
                        <Col span={12}>
                            <Button
                                block
                                icon={<ReloadOutlined />}
                                onClick={handleReset}
                            >
                                Reset
                            </Button>
                        </Col>
                        <Col span={12}>
                            <Button
                                block
                                type="primary"
                                icon={<SearchOutlined />}
                                onClick={handleApply}
                            >
                                Apply
                            </Button>
                        </Col>
                    </Row>
                }
            >
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={currentFilters}
                >
                    <Form.Item
                        label="Search Text"
                        name="searchText"
                    >
                        <Input placeholder="Variant title, SKU, barcode..." />
                    </Form.Item>

                    <Form.Item
                        label="Shopify Store"
                        name="shopifyStoreId"
                    >
                        <Select placeholder="Select store">
                            <Option value="all">All Stores</Option>
                            {/* TODO: Load stores dynamically */}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Has SKU"
                        name="hasSku"
                    >
                        <Select placeholder="Select option" allowClear>
                            <Option value="true">Yes</Option>
                            <Option value="false">No</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Has Business SKU Mapping"
                        name="hasBusinessSku"
                    >
                        <Select placeholder="Select option" allowClear>
                            <Option value="true">Mapped</Option>
                            <Option value="false">Not Mapped</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Inventory Status"
                        name="inventoryStatus"
                    >
                        <Select placeholder="Select status">
                            <Option value="all">All</Option>
                            <Option value="in_stock">In Stock (&gt;10)</Option>
                            <Option value="low_stock">Low Stock (1-10)</Option>
                            <Option value="out_of_stock">Out of Stock (≤0)</Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Drawer>
        </>
    );
};

export default ShopifyVariantsFilter;
